var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-content" }, [
      _c("div", { staticClass: "main-content-inner" }, [
        _c(
          "div",
          {
            staticClass: "breadcrumbs ace-save-state",
            attrs: { id: "breadcrumbs" }
          },
          [
            _c(
              "ul",
              { staticClass: "breadcrumb" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "router-link",
                  { attrs: { tag: "li", to: { name: "group" } } },
                  [_c("a", [_vm._v("ゲートグループ一覧")])]
                ),
                _vm._v(" "),
                _c("li", { staticClass: "active" }, [
                  _vm._v("ゲートグループ編集")
                ])
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "page-content" }, [
          _vm.loading
            ? _c("div", { attrs: { id: "loading" } }, [
                _c("div", { staticClass: "loadingMsg" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _vm.errorMessageLogs !== ""
              ? _c("div", { staticClass: "alert alert-danger" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.errorMessageLogs) + "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.message
              ? _c("div", { staticClass: "alert alert-success" }, [
                  _vm._v("\n          " + _vm._s(_vm.message) + "\n        ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c(
                  "form",
                  { staticClass: "form-horizontal", attrs: { role: "form" } },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("div", { staticClass: "col-md-offset-2 col-md-10" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass:
                            "col-sm-2 control-label no-padding-right",
                          attrs: { for: "form-field-1" }
                        },
                        [_vm._v("ゲートグループID")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-10" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.groupInfor.groupId,
                              expression: "groupInfor.groupId"
                            }
                          ],
                          staticClass: "form-control input-sm",
                          attrs: {
                            type: "text",
                            disabled: "",
                            placeholder: "ゲートグループId"
                          },
                          domProps: { value: _vm.groupInfor.groupId },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.groupInfor,
                                "groupId",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass:
                            "col-sm-2 control-label no-padding-right",
                          attrs: { for: "form-field-1" }
                        },
                        [
                          _vm._v("ゲートグループ名 "),
                          _c("font", { staticClass: "input-required" }, [
                            _vm._v("※必須")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-10" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.groupInfor.name,
                              expression: "groupInfor.name"
                            }
                          ],
                          staticClass: "form-control input-sm",
                          attrs: {
                            type: "text",
                            id: "name",
                            placeholder: "ゲートグループ名"
                          },
                          domProps: { value: _vm.groupInfor.name },
                          on: {
                            blur: _vm.validateBeforeSubmit,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.groupInfor,
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "col-sm-2 control-label no-padding-right",
                          attrs: { for: "form-field-1" }
                        },
                        [_vm._v("ステータス")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-1" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.groupInfor.isValid,
                              expression: "groupInfor.isValid"
                            }
                          ],
                          staticClass: "ace ace-switch ace-switch-4",
                          attrs: { name: "switch-field-1", type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.groupInfor.isValid)
                              ? _vm._i(_vm.groupInfor.isValid, null) > -1
                              : _vm.groupInfor.isValid
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.groupInfor.isValid,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.groupInfor.isValid = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.groupInfor.isValid = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.$set(_vm.groupInfor, "isValid", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", {
                        staticClass: "col-sm-2 control-label no-padding-right",
                        attrs: { for: "form-field-1" }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-10" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "btn cancel_bottom",
                              attrs: { to: { name: "group" } }
                            },
                            [
                              _vm._v(
                                "\n                  キャンセル\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info save_group_bottom",
                              attrs: { type: "button" },
                              on: { click: _vm.editInforGroup }
                            },
                            [
                              _vm._v(
                                "\n                  保存\n                "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "alert alert-danger",
                        attrs: { id: "error-alert" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.message) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "alert alert-success",
                        attrs: { id: "success-alert" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.message) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "accordion-style1 panel-group",
                        attrs: { id: "accordion" }
                      },
                      [
                        _c("div", { staticClass: "panel panel-default" }, [
                          _c("div", { staticClass: "panel-heading" }, [
                            _c("h4", { staticClass: "panel-title" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "accordion-toggle",
                                  attrs: {
                                    "data-toggle": "collapse",
                                    href: "#passage",
                                    "aria-expanded": "true"
                                  },
                                  on: { click: _vm.getData }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "ace-icon fa fa-angle-right bigger-110",
                                    attrs: {
                                      "data-icon-hide":
                                        "ace-icon fa fa-angle-down",
                                      "data-icon-show":
                                        "ace-icon fa fa-angle-right"
                                    }
                                  }),
                                  _vm._v(
                                    "\n                       ユーザー\n                    "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "panel-collapse collapse",
                              attrs: { id: "passage" }
                            },
                            [
                              _c("div", { staticClass: "panel-body" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table table-striped table-bordered table-hover dataTable",
                                    staticStyle: { "min-width": "100%" }
                                  },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _vm.listUserGroup != null
                                          ? _c(
                                              "th",
                                              {
                                                staticClass: "center",
                                                staticStyle: {
                                                  width: "50px!important"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  { staticClass: "pos-rel" },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.selectAllUser,
                                                          expression:
                                                            "selectAllUser"
                                                        }
                                                      ],
                                                      staticClass: "ace",
                                                      attrs: {
                                                        type: "checkbox"
                                                      },
                                                      domProps: {
                                                        checked: Array.isArray(
                                                          _vm.selectAllUser
                                                        )
                                                          ? _vm._i(
                                                              _vm.selectAllUser,
                                                              null
                                                            ) > -1
                                                          : _vm.selectAllUser
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$a =
                                                              _vm.selectAllUser,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = null,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                (_vm.selectAllUser = $$a.concat(
                                                                  [$$v]
                                                                ))
                                                            } else {
                                                              $$i > -1 &&
                                                                (_vm.selectAllUser = $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  ))
                                                            }
                                                          } else {
                                                            _vm.selectAllUser = $$c
                                                          }
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "lbl"
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("ユーザーID")]),
                                        _vm._v(" "),
                                        _c("th", [
                                          _vm._v("ユーザー名/ふりがな")
                                        ]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("備考.1")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("備考.2")]),
                                        _vm._v(" "),
                                        _c("th", { staticClass: "center" }, [
                                          _vm._v("ステータス")
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _vm.listUserGroup != null
                                      ? _c(
                                          "tbody",
                                          [
                                            _vm._l(_vm.listUserGroup, function(
                                              item,
                                              index
                                            ) {
                                              return [
                                                _c(
                                                  "tr",
                                                  {
                                                    key: index,
                                                    class: {
                                                      selected: _vm.rowSelected(
                                                        item.groupPassageId
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass: "center",
                                                        staticStyle: {
                                                          width: "50px"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "pos-rel"
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.selectedUserId,
                                                                  expression:
                                                                    "selectedUserId"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "ace",
                                                              attrs: {
                                                                type: "checkbox"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  item.groupPassageId,
                                                                checked: Array.isArray(
                                                                  _vm.selectedUserId
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.selectedUserId,
                                                                      item.groupPassageId
                                                                    ) > -1
                                                                  : _vm.selectedUserId
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  var $$a =
                                                                      _vm.selectedUserId,
                                                                    $$el =
                                                                      $event.target,
                                                                    $$c = $$el.checked
                                                                      ? true
                                                                      : false
                                                                  if (
                                                                    Array.isArray(
                                                                      $$a
                                                                    )
                                                                  ) {
                                                                    var $$v =
                                                                        item.groupPassageId,
                                                                      $$i = _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                    if (
                                                                      $$el.checked
                                                                    ) {
                                                                      $$i < 0 &&
                                                                        (_vm.selectedUserId = $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                    } else {
                                                                      $$i >
                                                                        -1 &&
                                                                        (_vm.selectedUserId = $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                    }
                                                                  } else {
                                                                    _vm.selectedUserId = $$c
                                                                  }
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", {
                                                              staticClass: "lbl"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(item.user.userId)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(item.user.name) +
                                                          "/" +
                                                          _vm._s(
                                                            item.user.furigana
                                                          )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.user.option1
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.user.option2
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      { staticClass: "center" },
                                                      [
                                                        item.user.isValid
                                                          ? _c("span", [
                                                              _vm._v("有効")
                                                            ])
                                                          : _c("span", [
                                                              _vm._v("無効")
                                                            ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            })
                                          ],
                                          2
                                        )
                                      : _c("tbody", [
                                          _c("tr", [
                                            _c(
                                              "td",
                                              { attrs: { colspan: "5" } },
                                              [_vm._v(_vm._s(_vm.messageData))]
                                            )
                                          ])
                                        ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "row pd-t-10" }, [
                                  _c("div", { staticClass: "col-xs-12" }, [
                                    _vm.pagesGroupUser > 0 &&
                                    _vm.listUserGroup !== null
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dataTables_paginate paging_simple_numbers"
                                          },
                                          [
                                            _c("paginate", {
                                              attrs: {
                                                "page-count":
                                                  _vm.pagesGroupUser,
                                                "page-range": 3,
                                                "margin-pages": 2,
                                                "click-handler":
                                                  _vm.handleCurrentChangeGroupUser,
                                                "prev-text": "<<",
                                                "next-text": ">>",
                                                "container-class": "pagination",
                                                "page-class": "page-item"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-cus btn-right btn-add",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        _vm.addUser(_vm.groupInfor.groupId)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    ユーザーの関連付けを追加\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn-cus btn-right btn-delete",
                                    attrs: {
                                      href: "#process",
                                      "data-toggle": "modal"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.resetStatus()
                                      }
                                    }
                                  },
                                  [_vm._v("チェックしたユーザーの関連付け解除")]
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "panel panel-default" }, [
                          _c("div", { staticClass: "panel-heading" }, [
                            _c("h4", { staticClass: "panel-title" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "accordion-toggle",
                                  attrs: {
                                    "data-toggle": "collapse",
                                    href: "#relation-gate"
                                  },
                                  on: { click: _vm.getDataGroupGate }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "bigger-110 ace-icon fa fa-angle-right",
                                    attrs: {
                                      "data-icon-hide":
                                        "ace-icon fa fa-angle-down",
                                      "data-icon-show":
                                        "ace-icon fa fa-angle-right"
                                    }
                                  }),
                                  _vm._v(
                                    "\n                       ゲート\n                    "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "panel-collapse collapse",
                              attrs: {
                                id: "relation-gate",
                                "aria-expanded": "true"
                              }
                            },
                            [
                              _c("div", { staticClass: "panel-body" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table table-striped table-bordered table-hover dataTable",
                                    staticStyle: { "min-width": "100%" }
                                  },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _vm.listGateGroup != null
                                          ? _c(
                                              "th",
                                              {
                                                staticClass: "center",
                                                staticStyle: {
                                                  width: "50px!important"
                                                }
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  { staticClass: "pos-rel" },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.selectAllGate,
                                                          expression:
                                                            "selectAllGate"
                                                        }
                                                      ],
                                                      staticClass: "ace",
                                                      attrs: {
                                                        type: "checkbox"
                                                      },
                                                      domProps: {
                                                        checked: Array.isArray(
                                                          _vm.selectAllGate
                                                        )
                                                          ? _vm._i(
                                                              _vm.selectAllGate,
                                                              null
                                                            ) > -1
                                                          : _vm.selectAllGate
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$a =
                                                              _vm.selectAllGate,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = null,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                (_vm.selectAllGate = $$a.concat(
                                                                  [$$v]
                                                                ))
                                                            } else {
                                                              $$i > -1 &&
                                                                (_vm.selectAllGate = $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  ))
                                                            }
                                                          } else {
                                                            _vm.selectAllGate = $$c
                                                          }
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "lbl"
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("ゲートID")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("ゲート名")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("製品名")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("備考.1")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("備考.2")]),
                                        _vm._v(" "),
                                        _c("th", { staticClass: "center" }, [
                                          _vm._v("ステータス")
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _vm.listGateGroup != null
                                      ? _c(
                                          "tbody",
                                          [
                                            _vm._l(_vm.listGateGroup, function(
                                              item,
                                              index
                                            ) {
                                              return [
                                                item.gate.isValid
                                                  ? _c(
                                                      "tr",
                                                      {
                                                        key: index,
                                                        class: {
                                                          selected: _vm.rowSelectedGate(
                                                            item.relationId
                                                          )
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "center",
                                                            staticStyle: {
                                                              width: "50px"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "pos-rel"
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.selectedGateId,
                                                                      expression:
                                                                        "selectedGateId"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "ace",
                                                                  attrs: {
                                                                    type:
                                                                      "checkbox"
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      item.relationId,
                                                                    checked: Array.isArray(
                                                                      _vm.selectedGateId
                                                                    )
                                                                      ? _vm._i(
                                                                          _vm.selectedGateId,
                                                                          item.relationId
                                                                        ) > -1
                                                                      : _vm.selectedGateId
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      var $$a =
                                                                          _vm.selectedGateId,
                                                                        $$el =
                                                                          $event.target,
                                                                        $$c = $$el.checked
                                                                          ? true
                                                                          : false
                                                                      if (
                                                                        Array.isArray(
                                                                          $$a
                                                                        )
                                                                      ) {
                                                                        var $$v =
                                                                            item.relationId,
                                                                          $$i = _vm._i(
                                                                            $$a,
                                                                            $$v
                                                                          )
                                                                        if (
                                                                          $$el.checked
                                                                        ) {
                                                                          $$i <
                                                                            0 &&
                                                                            (_vm.selectedGateId = $$a.concat(
                                                                              [
                                                                                $$v
                                                                              ]
                                                                            ))
                                                                        } else {
                                                                          $$i >
                                                                            -1 &&
                                                                            (_vm.selectedGateId = $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              ))
                                                                        }
                                                                      } else {
                                                                        _vm.selectedGateId = $$c
                                                                      }
                                                                    }
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "lbl"
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.gate.gateId
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.gate.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.gate
                                                                .gateModelName
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.gate.option1
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("td", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.gate.option2
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "center"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.gate.status
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            })
                                          ],
                                          2
                                        )
                                      : _c("tbody", [
                                          _c("tr", [
                                            _c(
                                              "td",
                                              { attrs: { colspan: "6" } },
                                              [_vm._v(_vm._s(_vm.messageData))]
                                            )
                                          ])
                                        ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "row pd-t-10" }, [
                                  _c("div", { staticClass: "col-xs-12" }, [
                                    _vm.pagesGroupGate > 0 &&
                                    _vm.listGateGroup !== null
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dataTables_paginate paging_simple_numbers"
                                          },
                                          [
                                            _c("paginate", {
                                              attrs: {
                                                "page-count":
                                                  _vm.pagesGroupGate,
                                                "page-range": 3,
                                                "margin-pages": 2,
                                                "click-handler":
                                                  _vm.handleCurrentChangeGroupGate,
                                                "prev-text": "<<",
                                                "next-text": ">>",
                                                "container-class": "pagination",
                                                "page-class": "page-item"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-cus btn-right btn-add",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        _vm.addGate(_vm.groupInfor.groupId)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    ゲートの関連付けを追加\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn-cus btn-right btn-delete",
                                    attrs: {
                                      href: "#processGate",
                                      "data-toggle": "modal"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.resetStatusGate()
                                      }
                                    }
                                  },
                                  [_vm._v("チェックしたゲートの関連付け解除")]
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal fade", attrs: { id: "process", tabindex: "-1" } },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("span", { staticClass: "progress-question" }, [
                _vm._v("このユーザーとの関連付けを解除しますか？")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "progress",
                  class: {
                    "progress-striped": !_vm.success,
                    active: !_vm.success,
                    hide: !_vm.success
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "progress-bar", style: _vm.progressWidth },
                    [
                      _c("span", [
                        _vm._v(_vm._s(Math.round(_vm.progress)) + "%")
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.successUser > 0
                ? _c("span", { staticClass: "success-label" }, [
                    _vm._v(
                      _vm._s(_vm.countUser) +
                        "件中" +
                        _vm._s(_vm.successUser) +
                        "件を解除しました。"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errorMessage.length > 0
                ? _c("div", [
                    _c("span", { staticClass: "error-box-title" }, [
                      _vm._v("解除失敗")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "error-box" },
                      [
                        _vm._l(_vm.errorMessage, function(item) {
                          return [
                            _c("p", {
                              key: item,
                              domProps: { innerHTML: _vm._s(item) }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-success pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v("OK")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-danger pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { disabled: _vm.isDisabled },
                      on: {
                        click: function($event) {
                          _vm.deleteRelationUser()
                        }
                      }
                    },
                    [_vm._v("実行")]
                  )
                : _vm._e()
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "processGate", tabindex: "-1" }
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("span", { staticClass: "progress-question" }, [
                _vm._v("このゲートとの関連付けを解除しますか？")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "progress",
                  class: {
                    "progress-striped": !_vm.success,
                    active: !_vm.success,
                    hide: !_vm.success
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "progress-bar", style: _vm.progressWidth },
                    [
                      _c("span", [
                        _vm._v(_vm._s(Math.round(_vm.progress)) + "%")
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.successGate > 0
                ? _c("span", { staticClass: "success-label" }, [
                    _vm._v(
                      _vm._s(_vm.countGate) +
                        "件中" +
                        _vm._s(_vm.successGate) +
                        "件を解除しました。"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errorMessage.length > 0
                ? _c("div", [
                    _c("span", { staticClass: "error-box-title" }, [
                      _vm._v("解除失敗")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "error-box" },
                      [
                        _vm._l(_vm.errorMessage, function(item) {
                          return [
                            _c("p", {
                              key: item,
                              domProps: { innerHTML: _vm._s(item) }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-success pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v("OK")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-danger pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { disabled: _vm.isDisabled },
                      on: {
                        click: function($event) {
                          _vm.deleteRelationGate()
                        }
                      }
                    },
                    [_vm._v("実行")]
                  )
                : _vm._e()
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
      _vm._v(" "),
      _c("a", { attrs: { href: "#/" } }, [_vm._v("メインメニュー")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [
        _c("h3", [_vm._v("ゲートグループ編集")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-offset-2 col-md-10" }, [
      _c("span", { staticClass: "error_m", attrs: { id: "name_error" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "smaller lighter frofile-title no-margin" }, [
        _vm._v("関連付け解除")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "smaller lighter frofile-title no-margin" }, [
        _vm._v("関連付け解除")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5249462", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5249462","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/group/GroupEdit.vue
// module id = null
// module chunks = 